import { render } from "./AndroidComponent.vue?vue&type=template&id=3523ae28&scoped=true"
import script from "./AndroidComponent.vue?vue&type=script&lang=js"
export * from "./AndroidComponent.vue?vue&type=script&lang=js"

import "./AndroidComponent.vue?vue&type=style&index=0&id=3523ae28&lang=css"
import "./AndroidComponent.vue?vue&type=style&index=1&id=3523ae28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3523ae28"]])

export default __exports__